// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a0e99d0b","732":"9a305367"}[chunkId] + ".chunk.js";
};